/**
 * sources
 * Asset manifest consumed by Resources.
 * Each entry: { name: string, type: 'gltfModel'|'texture'|'cubeTexture', path: string|string[] }
 */
export default []
